import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../app/store";
import { Button, Col, Form, Row } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import { useRef, useState } from "react";
import { removeCiot, addCiot, removeCiotTodos } from "../../../features/manifestoSlice";
import { CiotInterface, SelectObjectRemoveInterface } from "../../../interfaces";
import { getUuidV4, goToFocus, validarCPFCNPJ } from "../../../utils/utils";
import { ButtonRemover, ButtonTrash, JTable, JTBody, JTHead } from "../../../components/Components";
import { useQuestion } from "../../../components/ModalQuestion/useModalQuestion";
import { useModalMessage } from "../../../components/ModalMessage/useModalMessage";

const initialForm: CiotInterface = {
    id: 0,
    ciot: '',
    cpfcnpj: ''
}

export default function Ciot() {
    const dispatch = useDispatch();
    const [selecionado, setSelecionado] = useState<number | string>('');
    const lista = useSelector((state: RootState) => state.manifesto.manifesto.modal_rodoviario?.infANTT.infCIOT);
    const [form, setForm] = useState(initialForm)
    const numeroRef = useRef<HTMLInputElement>(null);
    const cpfCnpjRef = useRef<HTMLInputElement>(null);
    const { confirm, ConfirmModal } = useQuestion();
    const { alertModal, ModalMessageEl } = useModalMessage();
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;

        setForm((prev) => ({
            ...prev,
            [name]: value.trim()
        }))
    }

    const validarPreenchimento = () => {

        if (form.ciot === "") {
            goToFocus(numeroRef);
            alertModal("Informe o número do CIOT.");
            return false;
        }

        if (form.ciot.trim().length !== 12) {
            goToFocus(numeroRef);
            alertModal("CIOT deve ter 12 caracteres.");
            return false;
        }

        if (form.cpfcnpj === "") {
            goToFocus(cpfCnpjRef);
            alertModal('Informe o CPF/CNPJ.');
            return false;
        }

        if (!validarCPFCNPJ(form.cpfcnpj)) {
            goToFocus(cpfCnpjRef);
            alertModal('CPF/CNPJ inválido.');
            return false;
        }

        if (lista.find((item: CiotInterface) => item.ciot === form.ciot && item.cpfcnpj === form.cpfcnpj)) {
            goToFocus(numeroRef);
            alertModal('Número do CIOT já foi adicionado para CPF/CNPJ informado.');
            return false;
        }

        return true;
    }

    const handleAdd = () => {

        if (validarPreenchimento()) {
            dispatch(addCiot({
                ...form,
                id: getUuidV4()
            }));
            setForm(initialForm);
            goToFocus(numeroRef);
        }
    }

    const handleRemover = async (value: SelectObjectRemoveInterface) => {
        setSelecionado(value.id)
        const confirmed = await confirm({
            message: <>Deseja realmente remover <strong>{value.title}</strong> ?</>,
            title: "Confirmação"
        });

        if (confirmed) {
            dispatch(removeCiot(value.id));
            setForm(initialForm);
        }
        setSelecionado('')
    }

    const removerTudo = async () => {
        if (lista.length > 0) {
            const confirmed = await confirm({
                message: <>Remover todos ?</>,
                title: "Confirmação"
            });
            if (confirmed) {
                dispatch(removeCiotTodos());
                goToFocus(numeroRef);
            }
        }
    }

    return (<>
        <Row className="g-2 mb-3">
            <Col md={'auto'} className="">
                <Form.Group controlId="ciot">
                    <Form.Label>Número Ciot</Form.Label>
                    <Form.Control name="ciot"
                        ref={numeroRef}
                        maxLength={12} type="text"
                        onChange={handleChange} value={form.ciot} />
                </Form.Group>
            </Col>

            <Col md={'auto'}>
                <Form.Group controlId="ciot-cpfcnpj">
                    <Form.Label>CPF/CNPJ</Form.Label>
                    <Form.Control name="cpfcnpj" value={form.cpfcnpj}
                        ref={cpfCnpjRef} 
                        maxLength={14} type="text" onChange={handleChange} />
                </Form.Group>
            </Col>

            <Col md={'auto'} className="d-flex align-items-end">
                <Form.Group >
                    <Button variant="primary" onClick={handleAdd}>
                        <FontAwesomeIcon icon={faPlus} />  Adicionar
                    </Button>
                </Form.Group>
            </Col>
        </Row>
        <Row>
            <JTable>
                <JTHead>
                    <tr>
                        <th className="text-center" style={{ width: '2.5rem' }}>
                            <ButtonTrash onClick={() => removerTudo()} icon={faTrashAlt} />
                        </th>
                        <th>Número CIOT</th>
                        <th>CPF/CNPJ</th>
                    </tr>
                </JTHead>

                <JTBody>
                    {lista?.map((item: CiotInterface) => (
                        <tr key={item.id} className={item.id.toString() === selecionado.toString() ? 'table-danger' : ''}>
                            <td className="text-center">
                                <ButtonRemover onClick={() => handleRemover({ id: item.id, title: item.ciot })} />
                            </td>
                            <td>{item.ciot}</td>
                            <td>{item.cpfcnpj}</td>
                        </tr>
                    ))}
                </JTBody>
            </JTable>
        </Row>
        {ConfirmModal}
        {ModalMessageEl}
    </>)
}
